module.exports = __webpack_public_path__ + "45292dd75a0f70a55aa1caefbaa9fe11.svg";